"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.Ceres = void 0;
var Colony_1 = require("./Colony");
var ColonyName_1 = require("./ColonyName");
var ColonyBenefit_1 = require("./ColonyBenefit");
var Resources_1 = require("../Resources");
var Ceres = (function (_super) {
    __extends(Ceres, _super);
    function Ceres() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.name = ColonyName_1.ColonyName.CERES;
        _this.description = 'Steel';
        _this.buildType = ColonyBenefit_1.ColonyBenefit.GAIN_PRODUCTION;
        _this.buildResource = Resources_1.Resources.STEEL;
        _this.tradeType = ColonyBenefit_1.ColonyBenefit.GAIN_RESOURCES;
        _this.tradeQuantity = [1, 2, 3, 4, 6, 8, 10];
        _this.tradeResource = Resources_1.Resources.STEEL;
        _this.colonyBonusType = ColonyBenefit_1.ColonyBenefit.GAIN_RESOURCES;
        _this.colonyBonusQuantity = 2;
        _this.colonyBonusResource = Resources_1.Resources.STEEL;
        return _this;
    }
    return Ceres;
}(Colony_1.Colony));
exports.Ceres = Ceres;
